import { addDays } from 'date-fns';
import { formatAPIDayParam } from '@airasia-common/libraries/datetime';
import { transformGuestsToOccupancy } from '@airasia-common/libraries/utilities/OccupancyHelper';
import {
  FILTER_TO_HOTEL_SEARCH_RESULTS,
  SORT_TYPE,
} from '@airasia-common/libraries/constants';

export const hotelFilterDefault = {
  currency: 'MYR',
  countryCode: 'MY',
  languageId: 'en-gb',
  roomsCount: '1',
  adults: '2',
  checkin: formatAPIDayParam(addDays(new Date(), 7)),
  checkout: formatAPIDayParam(addDays(new Date(), 10)),
};

const getSortBy = sort => {
  if (!sort) {
    return SORT_TYPE.RECOMMENDED;
  }

  return Object.keys(FILTER_TO_HOTEL_SEARCH_RESULTS).find(
    key => FILTER_TO_HOTEL_SEARCH_RESULTS[key] === sort
  );
};

export const mapHotelListingUrlParamsToFilterState = urlParams => {
  const adults = urlParams?.adults || hotelFilterDefault?.adults;

  return {
    checkin: urlParams.fromDate || hotelFilterDefault.checkin,
    checkout: urlParams.toDate || hotelFilterDefault.checkout,
    locationId: urlParams.destination,
    roomsCount: urlParams.rooms || hotelFilterDefault.roomsCount,
    adults,
    children: urlParams.children,
    occupancy: transformGuestsToOccupancy(adults, urlParams.children),
    countryCode: urlParams.countryCode || hotelFilterDefault.countryCode,
    languageId: urlParams.languageId || hotelFilterDefault.languageId,
    currency: urlParams.currency || hotelFilterDefault.currency,
    sortBy: getSortBy(urlParams.sort),
    guestRating: urlParams.F_R || '',
    lemonAgentId:
      urlParams.agent ||
      urlParams.lemon_agent_id ||
      urlParams.lemonAgentId ||
      '',
    channel: urlParams.channel || '',
    focusId: urlParams.focusId || '',
    messageId: urlParams.messageId || '',
    aaId: urlParams.aaId || '',
    applyBigpoints: urlParams.applyBigpoints === 'true',
    amenity: urlParams.amenity || '',
    hotelClass: urlParams.hotelClass
      ? !Array.isArray(urlParams.hotelClass)
        ? [urlParams.hotelClass]
        : urlParams.hotelClass
      : [],
    paymentType: urlParams.paymentType
      ? !Array.isArray(urlParams.paymentType)
        ? [urlParams.paymentType]
        : urlParams.paymentType
      : [],
    debug: urlParams.debug || '',
    category: urlParams.propertyType
      ? Array.isArray(urlParams.propertyType)
        ? urlParams.propertyType
        : [urlParams.propertyType]
      : [],
    isCrossSell: urlParams?.isCrossSell || '',
  };
};
